import React from 'react';
import styled from 'styled-components';
import { Flex, Box } from '@rebass/grid';
import media from '../media';

const StyledContainer = styled.div`
	max-width: 100%;
	margin: 0 ${props => props.theme.spacing * 1.5}rem;

	${media.tabletOnly`
		margin: 0 ${props => props.theme.spacing * 3}rem;
	`}

	${media.desktopSmall`
		margin: 0 ${props => props.theme.spacing * 4.5}rem;
	`}

	${media.containerBreakpoint`
		max-width: ${props => props.theme.pageMaxWidth}px;
		margin: 0 auto;
	`}

	[name="Container"] {
		margin: 0;
	}
`;

export const Container = props => <StyledContainer {...props} name="Container" />;

export const Columns = ({
	gapless,
	flexWrap,
	...props
}) => {
	const gap = gapless ? 0 : '-1.5rem';

	return (
		<Flex
			{...props}
			mx={gap}
			flexWrap={flexWrap || 'wrap'}
		/>
	);
};

export const Row = Columns;

export const Column = ({
	mobile,
	mobileMedium,
	mobileLarge,
	tablet,
	desktopSmall,
	desktopLarge,
	retina,
	gapless,
	flex,
	width,
	...props
}) => {
	const breakpoints = [
		'100%',
		mobile || '100%',
		mobileMedium || mobile || '100%',
		mobileLarge || mobileMedium || mobile || '100%',
		tablet || mobileLarge || mobileMedium || mobile || 'auto',
		desktopSmall || tablet || mobileLarge || mobileMedium || mobile || 'auto',
		desktopLarge || desktopSmall || tablet || mobileLarge || mobileMedium || mobile || 'auto',
		retina || desktopLarge || desktopSmall || tablet || mobileLarge || mobileMedium || mobile || 'auto'
	];

	const gap = gapless ? 0 : '1.5rem';
	const defaultFlex = (
		mobile || mobileMedium || mobileLarge || tablet
		|| desktopSmall || desktopLarge || retina
	) ? 'none' : '1 1 auto';

	return (
		<Box
			width={width || breakpoints}
			{...props}
			px={gap}
			mb={gap}
			flex={flex || defaultFlex}
		/>
	);
};
